module.exports = __webpack_public_path__ + "img/icon10.5284983d.png";